module.exports = __webpack_public_path__ + "static/media/my.50be507f.svg";